/* KaryaGold — Gold swatch hover → primary card image swap.
   Works for both card-product-fct (FCT carousel) and card-product
   (collection grid + related products). */

(function () {
  'use strict';

  function findPrimaryImage(card) {
    // Prefer the explicit FCT primary image.
    var primary = card.querySelector('[data-fct-card-primary]');
    if (primary) return primary;
    // Fallback for regular card-product: first <img> inside .card__media .media.
    var media = card.querySelector('.card__media .media');
    if (media) {
      var img = media.querySelector('img');
      if (img) return img;
    }
    return null;
  }

  function findCardRoot(swatch) {
    return (
      swatch.closest('[data-fct-card]') ||
      swatch.closest('.card-wrapper') ||
      swatch.closest('.product-card-wrapper')
    );
  }

  function bindSwatch(swatch) {
    if (swatch.dataset.kgSwatchBound === '1') return;
    swatch.dataset.kgSwatchBound = '1';

    var variantSrc = swatch.getAttribute('data-variant-src');
    var variantSrcset = swatch.getAttribute('data-variant-srcset');
    if (!variantSrc && !variantSrcset) return;

    var card = findCardRoot(swatch);
    if (!card) return;

    var primary = findPrimaryImage(card);
    if (!primary) return;

    // Cache the original src/srcset on the image once.
    if (!primary.dataset.kgOrigSrc) {
      primary.dataset.kgOrigSrc = primary.getAttribute('data-original-src') || primary.getAttribute('src') || '';
    }
    if (!primary.dataset.kgOrigSrcset) {
      primary.dataset.kgOrigSrcset =
        primary.getAttribute('data-original-srcset') || primary.getAttribute('srcset') || '';
    }

    var onEnter = function () {
      if (variantSrc) primary.setAttribute('src', variantSrc);
      if (variantSrcset) primary.setAttribute('srcset', variantSrcset);
      // Both class names: keeps fct-card legacy CSS working AND lets new
      // card-product styles target the same state with kg- prefix.
      card.classList.add('is-swatch-hover', 'is-kg-swatch-hover');
    };
    var onLeave = function () {
      if (primary.dataset.kgOrigSrc) primary.setAttribute('src', primary.dataset.kgOrigSrc);
      if (primary.dataset.kgOrigSrcset) primary.setAttribute('srcset', primary.dataset.kgOrigSrcset);
      card.classList.remove('is-swatch-hover', 'is-kg-swatch-hover');
    };

    swatch.addEventListener('mouseenter', onEnter);
    swatch.addEventListener('mouseleave', onLeave);
    swatch.addEventListener('focus', onEnter);
    swatch.addEventListener('blur', onLeave);
    swatch.addEventListener('touchstart', onEnter, { passive: true });
    swatch.addEventListener('touchend', onLeave, { passive: true });
  }

  function scan(root) {
    var swatches = (root || document).querySelectorAll('[data-kg-swatch-variant]');
    for (var i = 0; i < swatches.length; i++) bindSwatch(swatches[i]);
  }

  function init() {
    scan(document);

    // Re-scan when new cards are injected (e.g., facet filter updates, quick-add modals).
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-kg-swatch-variant]')) {
            bindSwatch(node);
          } else if (node.querySelectorAll) {
            scan(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
